import {
    Grid2,
    Table,
    TableContainer,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material';
import React, { useMemo } from 'react';
import SkeletonTable from '../../../components/atom/SkeletonTable';
import SortableTableCell from '../../../components/atom/SortableTableCell';
import { useTranslation } from 'react-i18next';

const CateringViewTable = ({ rows, total, loading, sort, sortDir, setSorting }) => {
    const { t } = useTranslation();

    const showableNotes = useMemo(() => {
        const byName = new Map();
        (rows || []).forEach((row) => {
            row.ticketTypeCustomFields
                ?.filter((field) => field.showInCatering === true)
                .forEach((note) => {
                    if (!byName.has(note.name)) byName.set(note.name, note);
                });
        });
        return [...byName.values()].sort((a, b) => a.name.localeCompare(b.name));
    }, [rows]);

    if (!rows) {
        return null;
    }

    return (
        <Grid2 size={{ xs: 12 }}>
            <TableContainer>
                <Table sx={{ minWidth: 700 }}>
                    <TableHead>
                        <TableRow>
                            <SortableTableCell
                                arrow={sort === 'ticketSeatName' ? sortDir : ''}
                                onClick={() => setSorting('ticketSeatName')}
                            >
                                {t('bookingitems.columns.ticketSeatName')}
                            </SortableTableCell>
                            <SortableTableCell
                                arrow={sort === 'name' ? sortDir : ''}
                                onClick={() => setSorting('name')}
                            >
                                {t('bookingitems.booker')}
                            </SortableTableCell>
                            <SortableTableCell
                                arrow={sort === 'note' ? sortDir : ''}
                                onClick={() => setSorting('note')}
                            >
                                {t('bookingitems.columns.note')}
                            </SortableTableCell>
                            <SortableTableCell
                                arrow={sort === 'checkinNote' ? sortDir : ''}
                                onClick={() => setSorting('checkinNote')}
                            >
                                {t('bookingitems.columns.checkinNote')}
                            </SortableTableCell>
                            {showableNotes.map((note) => (
                                <TableCell key={note.name} align="center">
                                    {note.name}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading ? (
                            <SkeletonTable rows={10} cells={4 + showableNotes.length} />
                        ) : (
                            rows?.map((row) => {
                                const notesByLabel = new Map(
                                    (row.booking.note || []).map((n) => [n.label, n.value]),
                                );
                                return (
                                    <TableRow key={row.id}>
                                        <TableCell>{row.ticketSeatName}</TableCell>
                                        <TableCell>
                                            {`${row.booking.firstName} ${row.booking.lastName}`}
                                            {row.booking.phone && (
                                                <div style={{ fontSize: '0.9rem', color: 'gray' }}>
                                                    {row.booking.phone}
                                                </div>
                                            )}
                                        </TableCell>
                                        <TableCell>{row.note}</TableCell>
                                        <TableCell>{row.checkinNote || ''}</TableCell>
                                        {showableNotes.map((note) => (
                                            <TableCell key={note.name} align="center">
                                                {notesByLabel.get(note.name)}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                );
                            })
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            <div style={{ marginTop: '1rem', textAlign: 'right' }}>
                {t('common.total')}: {total}
            </div>
        </Grid2>
    );
};

export default CateringViewTable;
